import { z } from 'zod';
export const partnerStatusSchema = z.enum([
    'InValidationProcess',
    'PendingPayment',
    'InRenewalProcess',
    'OnHold',
    'Active',
    'FormerPartner',
    'PaidNotActivated',
]);
export const PartnerStatus = partnerStatusSchema.enum;
